/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AuthVisitorAuthenticationCodeVerifiyRequest
 */
export interface AuthVisitorAuthenticationCodeVerifiyRequest {
  /**
   *
   * @type {string}
   * @memberof AuthVisitorAuthenticationCodeVerifiyRequest
   */
  code?: string
}

export function AuthVisitorAuthenticationCodeVerifiyRequestFromJSON(
  json: any
): AuthVisitorAuthenticationCodeVerifiyRequest {
  return AuthVisitorAuthenticationCodeVerifiyRequestFromJSONTyped(json, false)
}

export function AuthVisitorAuthenticationCodeVerifiyRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AuthVisitorAuthenticationCodeVerifiyRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    code: !exists(json, 'code') ? undefined : json['code']
  }
}

export function AuthVisitorAuthenticationCodeVerifiyRequestToJSON(
  value?: AuthVisitorAuthenticationCodeVerifiyRequest | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    code: value.code
  }
}
